<template>
  <div class="PopUp" v-if="open">
    <div class="content">
      <button class="close-btn" @click="open = false">
        <img class="close-ic" src="../../../assets/homePage/X.svg" />
      </button>
      <h3 class="header">
        {{ $t('summer_campaign.title_start') }}
        <span class="highlight">
          {{ $t('summer_campaign.title_end') }}
        </span>
      </h3>
      <p class="text">
        {{ $t('summer_campaign.text') }}
      </p>
      <img class="image" src="@/assets/homePage/se-summer-desktop.png" />
      <button class="button" @click="goToTariffs">
        {{ $t('summer_campaign.button') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SwedenPopUp',
  props: ['tariffRef'],
  data() {
    return { open: true };
  },
  methods: {
    goToTariffs() {
      this.open = false;

      this.tariffRef[0].scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });
    },
  },
};
</script>

<style scoped>
.PopUp {
  --header-f-size: 30px;
  --pop-up-padding: 22px;
  --text-row-gap: 15px;
  --paragraph-f-size: 16px;
  --button-f-size: 16px;
  --button-padding: 8px 32px;
  --paragraph-color: #41565d;
  --button-text-color: #2b4047;
  --button-border-radius: 30px;
  --button-box-shadow: 0px 3px 6px #00000029;
  --header-text-color: var(--button-text-color);
  --pop-up-border-radius: 21px;
  --qwello-yellow: #ffdf22;
  --row-gap: 16px;
  box-shadow: 0px 3px 6px #00000029;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  display: grid;
  place-items: center;
  z-index: 100;
}
.close-btn {
  margin-left: auto;
  margin-right: 14px;
  grid-row: 1;
}
.close-ic {
  height: 21px;
  width: 21px;
}
.content {
  position: relative;
  display: grid;
  background: #f8f8f8;
  grid-template-rows: 30px auto;
  row-gap: var(--row-gap);
  padding: var(--pop-up-padding);
  border-radius: var(--pop-up-border-radius);
  width: 95vw;
  align-items: center;
}
.header {
  grid-column: 1;
  grid-row: 2;
  color: var(--header-text-color);
  font-size: var(--header-f-size);
  line-height: 1.2;
  font-weight: bold;
  font-family: 'Foco';
}
.text {
  grid-column: 1;
  grid-row: 3;
  color: var(--paragraph-text-color);
  font-size: var(--paragraph-f-size);
}
.button {
  grid-column: 1;
  grid-row: 5;
  color: var(--button-text-color);
  font-size: var(--button-f-size);
  padding: var(--button-padding);
  border-radius: var(--button-border-radius);
  background-color: var(--qwello-yellow);
  width: max-content;
  align-self: flex-start;
}
.image {
  grid-column: 1;
  grid-row: 4;
}
@media (min-width: 768px) {
  .PopUp {
    --header-f-size: 35px;
    --pop-up-padding: 42px;
    --row-gap: 16px;
    --paragraph-f-size: 18px;
    --button-f-size: 14px;
    --button-padding: 12px 48px;
    --paragraph-text-color: #41565d;
    --button-text-color: #2b4047;
    --button-border-radius: 30px;
    --button-box-shadow: 0px 3px 6px #00000029;
    --header-text-color: var(--button-text-color);
    --pop-up-border-radius: 21px;
    --qwello-yellow: #ffdf22;
  }
  .close-btn {
    margin: 10px;
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 101;
    grid-row: unset;
  }
  .content {
    background: #f8f8f8;
    grid-template-columns: 1fr 30px minmax(200px, 1fr);
    grid-template-rows: 1fr auto 1fr;
    grid-auto-rows: auto;
    row-gap: var(--row-gap);
    padding: var(--pop-up-padding);
    border-radius: var(--pop-up-border-radius);
    width: 100%;
    max-width: 75vw;
    align-items: center;
  }
  .header {
    grid-column: 1/3;
    grid-row: 1;
    line-height: 1.2;
  }
  .highlight {
    background: var(--qwello-yellow);
    padding: 5px 4px;
    font-family: 'Foco';
  }
  .text {
    grid-column: 1;
    grid-row: 2;
    white-space: pre-wrap;
  }
  .button {
    grid-column: 1;
    grid-row: 3;
    width: max-content;
    align-self: center;
  }
  .image {
    grid-column: 3;
    grid-row: 1/-1;
  }
}
@media (min-width: 1281px) {
  .PopUp {
    --paragraph-f-size: 20px;
    --header-f-size: 50px;
    --button-f-size: 16px;
    --pop-up-padding: 82px;
    --row-gap: 32px;
  }
  .content {
    grid-template-columns: 1fr 60px minmax(480px, 1fr);
    max-width: 1423px;
  }
}
</style>
